import { render, staticRenderFns } from "./OvertimeReport.vue?vue&type=template&id=96ff1142"
import script from "./OvertimeReport.vue?vue&type=script&lang=js"
export * from "./OvertimeReport.vue?vue&type=script&lang=js"
import style0 from "./OvertimeReport.vue?vue&type=style&index=0&id=96ff1142&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports